import EditTimesheetHtml       from './schedule.timesheet.edit.html';
import HolidayModalHtml        from './templates/holiday.modal.html';
import ManageHolidaysModalHtml from './templates/manage-holidays.modal.html';
import SetUnavailableTimesHtml from './schedule.set-unavailable-times.html';
import WeekDefaultHtml         from './templates/week.default.html';

export function Schedule (
  $uibModal,
  $q,
  $translate,
  confirm,
  dateParsing,
  workshopAPI
) {

  //  getWeekRangeDisplay  used to build the date range displayed.
  //  params: startDate    Moment of date range start.
  //          endDate      Moment of date range end.
  var getWeekRangeDisplay = function (startDate, endDate) {
    return startDate.format('MMMM Do') + ' - ' + (startDate.format('MMMM') === endDate.format('MMMM') ?  endDate.format('Do') : endDate.format('MMMM Do'));
  };

  //  validateSchedule  used to confirm that both the
  //                    start and end inputs are populated
  //                    for a schedule.
  //  params: schedule  {Object} schedule object.
  var validateSchedule = function (schedule) {
    return !((schedule.local_start_time && !schedule.local_end_time) || (schedule.local_end_time && !schedule.local_start_time));
  };

  //  constructor                used to initialize class.
  //  params: defaultSchedule    {Object} saved default schedule.
  //          mechanicGroups     [Array] array of mechanic groups
  //                             containing names and ids.
  var Schedule = function(defaultSchedule, mechanicGroups) {
    var self = this;

    this.mechanicGroups = [];

    // Used to keep track of unavailable_times IDs that need to be deleted.
    this.unavailableCleanup = [];

    // Our schedule week starts on Monday, so add one day to start.
    this.weekRangeStart   = moment(dateParsing.weekRangeStart()).add(1, 'days');
    this.weekRangeEnd     = moment(dateParsing.weekRangeEnd(this.weekRangeStart));
    this.weekRangeDisplay = getWeekRangeDisplay(this.weekRangeStart, this.weekRangeEnd);

    this.routes = {
      save             : '/schedules',
      saveUnavailable  : '/unavailable_times',
      update           : '/schedule',
      updateUnavailable: '/unavailable_time'
    };

    // Used for schedule page.
    this.week = [
      {
        abbreviation   : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.MONDAY_ABBREVIATION'),
        day_of_week_int: 1,
        title          : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.MONDAY')
      },
      {
        abbreviation   : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.TUESDAY_ABBREVIATION'),
        day_of_week_int: 2,
        title          : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.TUESDAY')
      },
      {
        abbreviation   : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.WEDNESDAY_ABBREVIATION'),
        day_of_week_int: 3,
        title          : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.WEDNESDAY')
      },
      {
        abbreviation   : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.THURSDAY_ABBREVIATION'),
        day_of_week_int: 4,
        title          : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.THURSDAY')
      },
      {
        abbreviation   : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.FRIDAY_ABBREVIATION'),
        day_of_week_int: 5,
        title          : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.FRIDAY')
      },
      {
        abbreviation   : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.SATURDAY_ABBREVIATION'),
        day_of_week_int: 6,
        title          : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.SATURDAY')
      },
      {
        abbreviation   : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.SUNDAY_ABBREVIATION'),
        day_of_week_int: 7,
        title          : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.SUNDAY')
      },
    ];

    // Used for default schedules on an individual mechanic page.
    this.weekDefault = [
      {
        active           : true,
        content          : WeekDefaultHtml,
        day_of_week_int  : 1,
        is_default       : true,
        title            : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.MONDAY'),
        unavailable_times: []
      },
      {
        active           : false,
        content          : WeekDefaultHtml,
        day_of_week_int  : 2,
        is_default       : true,
        title            : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.TUESDAY'),
        unavailable_times: []
      },
      {
        active           : false,
        content          : WeekDefaultHtml,
        day_of_week_int  : 3,
        is_default       : true,
        title            : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.WEDNESDAY'),
        unavailable_times: []
      },
      {
        active           : false,
        content          : WeekDefaultHtml,
        day_of_week_int  : 4,
        is_default       : true,
        title            : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.THURSDAY'),
        unavailable_times: []
      },
      {
        active           : false,
        content          : WeekDefaultHtml,
        day_of_week_int  : 5,
        is_default       : true,
        title            : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.FRIDAY'),
        unavailable_times: []
      },
      {
        active           : false,
        content          : WeekDefaultHtml,
        day_of_week_int  : 6,
        is_default       : true,
        title            : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.SATURDAY'),
        unavailable_times: []
      },
      {
        active           : false,
        content          : WeekDefaultHtml,
        day_of_week_int  : 7,
        is_default       : true,
        title            : $translate.instant('GENERAL_SPACE.BOOKING_DAYS.SUNDAY'),
        unavailable_times: []
      }
    ];

    // Extend default schedule with previously saved default schedule.
    if (defaultSchedule) {
      this.isDefault = true;

      for (var i=0; i<7; i++) {
        if (defaultSchedule[i+1].id) {
          defaultSchedule[i+1].unavailable_times = defaultSchedule[i+1].unavailable_times || [];
          angular.extend(this.weekDefault[i], defaultSchedule[i+1]);
        }
      }
    }

    if (mechanicGroups) {

      // remove unnecessary key/value pair in returned group data
      for (var i=0; i<mechanicGroups.length; i++) {
        mechanicGroups[i] = mechanicGroups[i][i];
      }

      // configure this.mechanicGroups
      angular.forEach(mechanicGroups, function (mechanicGroup) {
        var group = { ids: [], names: [] };

        group.group_name = mechanicGroup.group_name;

        angular.forEach(mechanicGroup.mechanic_ids, function (mechanic) {

          angular.forEach(mechanic, function (name, id) {
            group.ids.push(id);
            group.names.push(name);
          });
        });

        self.mechanicGroups.push(group);
      });

      this.mechanicGroupIndex = 0;
      this.mechanicGroup = this.mechanicGroups[this.mechanicGroupIndex];
    }
  };

  //  addUnavailableDefaultSlot  used to add an empty unavailable time
  //                             object to the default schedule
  //                             unavailable times array.
  //  params: index              Integer for day of week index.
  Schedule.prototype.addUnavailableDefaultSlot = function (index) {
    var self = this;

    self.weekDefault[index].unavailable_times.push({ local_end_time: '', local_start_time: '' });
  };

  //  addUnavailableSlot  used to add an empty unavailable time
  //                      object to the provided list.
  //  params: date        "String" date for unavailable time.
  //          list        [Array] list of unavailable times.
  Schedule.prototype.addUnavailableSlot = function (date, list) {
    list.push({
      date            : date,
      local_end_time  : '',
      local_start_time: ''
    });
  };

  //  cleanupUnavailableDefaultTimes  used when saving from the mechanic page
  //                                  to loop through the unavailableCleanup
  //                                  array and delete each unavailable time.
  Schedule.prototype.cleanupUnavailableDefaultTimes = function () {
    var self = this;

    angular.forEach(self.unavailableCleanup, function (time) {
      time.id ? workshopAPI.delete('/unavailable_time', time.id): null;
    });
  };

  //  cleanupUnavailableTimes  used when saving from the schedule page
  //                           to loop through the unavailableCleanup
  //                           array and perform the appropriate
  //                           action. If time.date, delete the
  //                           unavailable time. Otherwise it is a
  //                           default, so just create an exception.
  Schedule.prototype.cleanupUnavailableTimes = function () {
    var self = this;

    angular.forEach(self.unavailableCleanup, function (time) {
      if (time.id) {
        time.date ?
        workshopAPI.delete('/unavailable_time', time.id) :
        workshopAPI.post('/unavailable_time_exceptions', {
          unavailable_time_exception: {
            date               : self.timesheetDate,
            unavailable_time_id: time.id
          }
        });
      }
    });
  };

  Schedule.prototype.configureSchedule = function (schedule) {
    angular.forEach(schedule, mechanic => {
      angular.forEach(mechanic.schedule, weekday => {
        angular.forEach(weekday.unavailable_times, unavailable => {
          if (unavailable.entire_day && unavailable.entire_day === 't') {
            weekday.unavailable_entire_day = true;
          }
        });
      });
    });

    return schedule;
  };

  //  delete   used to delete a schedule, whether
  //           default or not.
  //  params:  {Object} schedule object.
  Schedule.prototype.delete = function (schedule) {
    var self = this;

    var count = schedule.unavailable_times.length;

    for (var i=0; i<count; i++) {
      self.unavailableCleanup.push(schedule.unavailable_times.pop());
    }

    return workshopAPI.delete('/schedule', schedule.id).then(function () {
      self.isDefault ? self.cleanupUnavailableDefaultTimes() : self.cleanupUnavailableTimes();
    });
  };

  //  editTimesheet       used to launch the timesheet modal
  //                      for editing a selected days schedule.
  //  params: date        Moment of selected date.
  //          mechanicId  "String" of mechanic id.
  //          timesheet   {Object} existing or empty timesheet
  //                      object.
  Schedule.prototype.editTimesheet = function (date, mechanicId, timesheet) {
    timesheet.unavailable_times = timesheet.unavailable_times || [];
    timesheet                   = angular.copy(timesheet);

    return $uibModal.open({
      controller  : 'EditTimesheetCtrl',
      controllerAs: '$ctrl',
      templateUrl : EditTimesheetHtml,
      windowClass : 'lg-modal',
      resolve     : {
        date      : () => date,
        mechanicId: () => mechanicId,
        timesheet : () => timesheet
      }
    }).result;
  };

  //  filterMechanicGroup  used to build a group of schedules for
  //                       the currently active group of mechanics.
  //  params: schedule     {Object} schedules returned from backend.
  Schedule.prototype.filterMechanicGroup = function (schedule) {
    var self = this;

    var group = [];

    for (var id in schedule) {
      if (self.mechanicGroup.ids.indexOf(id) >= 0) {
        schedule[id].mechanic_id = id;
        group.push(schedule[id]);
      }
    }

    return group;
  };

  //  getDayOfMonth      used to get the day of the month
  //                     for display.
  //  params: dayOfWeek  Integer for day of week.
  Schedule.prototype.getDayOfMonth = function (dayOfWeek) {
    var self = this;

    return moment(self.weekRangeStart).add(dayOfWeek-1, 'days').format('D');
  };

  //  getNextGroup  used to get the next group of
  //                mechanic's data.
  Schedule.prototype.getNextGroup = function () {
    var self = this;

    if (self.mechanicGroupIndex !== (self.mechanicGroups.length-1)) {
      self.mechanicGroupIndex++;
      self.mechanicGroup = self.mechanicGroups[self.mechanicGroupIndex];
    }
  };

  //  getNextWeek           used to get the next week's data.
  //  params: showDefaults  Boolean to include default schedules
  //                        or not.
  Schedule.prototype.getNextWeek = function (showDefaults) {
    var self = this;

    self.weekRangeStart.add(7, 'days');
    self.weekRangeEnd.add(7, 'days');
    self.weekRangeDisplay = getWeekRangeDisplay(self.weekRangeStart, self.weekRangeEnd);

    return workshopAPI.post('/schedule/show', { start_date: self.weekRangeStart.format('YYYY-MM-DD'), include_default: showDefaults });
  };

  //  getPreviousGroup  used to get the previous group
  //                    of mechanic's data.
  Schedule.prototype.getPreviousGroup = function () {
    var self = this;

    if (self.mechanicGroupIndex !== 0) {
      self.mechanicGroupIndex--;
      self.mechanicGroup = self.mechanicGroups[self.mechanicGroupIndex];
    }
  };

  //  getPreviousWeek       used to get the previous week's data.
  //  params: showDefaults  Boolean to include default schedules
  //                        or not.
  Schedule.prototype.getPreviousWeek = function (showDefaults) {
    var self = this;

    self.weekRangeStart.subtract(7, 'days');
    self.weekRangeEnd.subtract(7, 'days');
    self.weekRangeDisplay = getWeekRangeDisplay(self.weekRangeStart, self.weekRangeEnd);

    return workshopAPI.post('/schedule/show', { start_date: self.weekRangeStart.format('YYYY-MM-DD'), include_default: showDefaults });
  };

  //  persistDefault  used to copy the current default schedule
  //                  for Monday to Tue-Fri.
  Schedule.prototype.persistDefault = function () {
    var self = this;

    for (var i=1; i<5; i++) {
      self.weekDefault[i].local_start_time = self.weekDefault[0].local_start_time;
      self.weekDefault[i].local_end_time = self.weekDefault[0].local_end_time;

      if ( self.weekDefault[i].unavailable_times.length ) {
        self.removeUnavailableSlot(self.weekDefault[i].unavailable_times);
      }

      self.weekDefault[i].unavailable_times = [];

      for (var j=0; j<self.weekDefault[0].unavailable_times.length; j++) {
        self.weekDefault[i].unavailable_times.push({
          day_of_week_int : self.weekDefault[i].day_of_week_int,
          local_end_time  : self.weekDefault[0].unavailable_times[j].local_end_time,
          local_start_time: self.weekDefault[0].unavailable_times[j].local_start_time
        });
      }
    }
  };

  //  removeUnavailableDefaultSlot  used to remove the last unavailable
  //                                time object from a default schedule's
  //                                unavailable times array.
  //  params: index                 Integer for day of week.
  Schedule.prototype.removeUnavailableDefaultSlot = function (index) {
    var self = this;

    if (self.weekDefault[index].unavailable_times.length) {
      self.unavailableCleanup.push(self.weekDefault[index].unavailable_times.pop());
    }
  };

  //  removeUnavailableSlot  used to remove the last unavailable
  //                         time object from a list of
  //                         unavailable times.
  //  params: list           [Array] of unavailable times.
  Schedule.prototype.removeUnavailableSlot = function (list) {
    var self = this;

    if (list.length) {
      self.unavailableCleanup.push(list.pop());
    }
  };

  //  save                          used to save and update schedules
  //                                and unavailable times.
  //  params: createSchedule        [Array] of new schedules.
  //          updateSchedule        [Array] of existing schedules.
  //          createUnavailability  [Array] of new unavailable times.
  //          updateUnavailability  [Array] of existing unavailable times.
  Schedule.prototype.save = function (createSchedule, updateSchedule, createUnavailability, updateUnavailability) {
    var self = this;

    return $q.when().then(function () {
      return createSchedule.length ? workshopAPI.post(self.routes.save, { schedules: createSchedule }) : $q.when();
    }).then(function () {
      return updateSchedule.length ? workshopAPI.patch(self.routes.update, { schedules: updateSchedule }) : $q.when();
    }).then(function () {
      return createUnavailability.length ? workshopAPI.post(self.routes.saveUnavailable, { unavailable_times: createUnavailability }) : $q.when();
    }).then(function () {
      return updateUnavailability.length ? workshopAPI.patch(self.routes.updateUnavailable, { unavailable_times: updateUnavailability }) : $q.when();
    }).then(function () {
      self.isDefault ? self.cleanupUnavailableDefaultTimes() : self.cleanupUnavailableTimes();
    }, function (err) {
      return $q.reject(err);
    });
  };

  //  saveDefault           used to build arrays for new and
  //                        existing default schedules and
  //                        unavailable times, then save.
  //  params: mechanic_id  "String" of mechanic id.
  Schedule.prototype.saveDefault = function (mechanic_id) {
    var self = this;

    var createSchedule = [];
    var createUnavailability = [];
    var isValidSchedule = true;
    var updateSchedule = [];
    var updateUnavailability = [];

    angular.forEach(self.weekDefault, function (weekday) {
      weekday = angular.copy(weekday);

      // Check for valid inputs.
      if (!validateSchedule(weekday)) {
        isValidSchedule = false;
      }

      // Build default schedule from self.weekDefault days with specified times.
      // If local_start_time, then local_end_time is defined as well.
      if (weekday.local_start_time || weekday.unavailable_times.length) {
        weekday.mechanic_id = mechanic_id;

        if (weekday.local_start_time && isValidSchedule) {
          weekday.local_start_time = moment().startOf('day').hour(moment(weekday.local_start_time).format('HH')).minute(moment(weekday.local_start_time).format('mm')).format('YYYY-MM-DDTHH:mm:ssZ');
          weekday.local_end_time = moment().startOf('day').hour(moment(weekday.local_end_time).format('HH')).minute(moment(weekday.local_end_time).format('mm')).format('YYYY-MM-DDTHH:mm:ssZ');
        }

        if (weekday.unavailable_times && weekday.unavailable_times.length) {

          for (var i=0; i<weekday.unavailable_times.length; i++) {
            var unavailable = weekday.unavailable_times[i];

            // Check for valid inputs.
            if (!validateSchedule(unavailable)) {
              isValidSchedule = false;
            }

            // Build default unavailable times from self.weekDefault.unavailable_times days
            // with specified times.
            // If local_start_time, then local_end_time is defined as well.
            if (unavailable.local_start_time && isValidSchedule) {
              unavailable.mechanic_id = mechanic_id;
              unavailable.day_of_week_int = weekday.day_of_week_int;
              unavailable.local_start_time = moment().startOf('day').hour(moment(unavailable.local_start_time).format('HH')).minute(moment(unavailable.local_start_time).format('mm')).format('YYYY-MM-DDTHH:mm:ssZ');
              unavailable.local_end_time = moment().startOf('day').hour(moment(unavailable.local_end_time).format('HH')).minute(moment(unavailable.local_end_time).format('mm')).format('YYYY-MM-DDTHH:mm:ssZ');

              if (unavailable.id) {
                updateUnavailability.push(unavailable);
              }
              else {
                createUnavailability.push(unavailable);
              }
            }
          }
        }

        if (weekday.id) {
          updateSchedule.push(weekday);
        }
        else {
          createSchedule.push(weekday);
        }
      }
    });

    if (isValidSchedule) {
      return self.save(createSchedule, updateSchedule, createUnavailability, updateUnavailability);
    }
    else {
      return $q.reject($translate.instant('JS_SPACE.MESSAGES.INVALID_SCHEDULE'));
    }
  };

  //  saveTimeSheet       used to build arrays for new and
  //                      existing schedules and
  //                      unavailable times, then save.
  //  params: date        Moment of selected date.
  //          mechanicId  "String" of mechanic id.
  //          timesheet   {Object} of schedule.
  Schedule.prototype.saveTimesheet = function (date, mechanicId, timesheet) {
    var self = this;

    var createSchedule = [];
    var createUnavailability = [];
    var isValidSchedule = true;
    var updateSchedule = [];
    var updateUnavailability = [];

    self.timesheetDate = date;

    // Check for valid inputs.
    if (!validateSchedule(timesheet)) {
      isValidSchedule = false;
    }

    // Build timesheet and push to appropriate array.
    // If local_start_time, then local_end_time is defined as well.
    if (timesheet.local_start_time && isValidSchedule) {

      // If user is editing a default schedule, we want to disguise
      // it as a non-default schedule. So we remove the id.
      if (timesheet.altered) {
        timesheet.id = timesheet.is_default === 't' ? null : timesheet.id;
        timesheet.date = date;
        timesheet.is_default = false;
      }

      /**
       * when using the time from a date after daylight savings and adding
       * it to a date before daylight savings, moment is converting the hour to
       * be an hour later. Because of that, we set the hour, second, minute, millisecond
       * separately to ensure that daylight savings is unaffected.
       * bugfix/WOR-1155
       */
      timesheet.local_start_time = moment(date)
        .hour(moment(timesheet.local_start_time).hour())
        .millisecond(moment(timesheet.local_start_time).millisecond())
        .minute(moment(timesheet.local_start_time).minute())
        .second(moment(timesheet.local_start_time).second())
        .format('YYYY-MM-DDTHH:mm:ssZ');
      timesheet.local_end_time = moment(date)
        .hour(moment(timesheet.local_end_time).hour())
        .millisecond(moment(timesheet.local_end_time).millisecond())
        .minute(moment(timesheet.local_end_time).minute())
        .second(moment(timesheet.local_end_time).second())
        .format('YYYY-MM-DDTHH:mm:ssZ');

      timesheet.mechanic_id      = mechanicId;

      if (timesheet.id) {
        updateSchedule.push(timesheet);
      }
      else {
        createSchedule.push(timesheet);
      }
    }

    if (timesheet.unavailable_times && timesheet.unavailable_times.length) {
      for (var i=0; i<timesheet.unavailable_times.length; i++) {
        var unavailable = timesheet.unavailable_times[i];

        // Ignore if unavailable time is a default.
        if (unavailable.date) {

          // Check for valid inputs.
          if (!validateSchedule(unavailable)) {
            isValidSchedule = false;
          }

          // Build unavailable times from timesheet.unavailable_times days
          // with specified times and push to appropriate array.
          // If local_start_time, then local_end_time is defined as well.
          if (unavailable.local_start_time && isValidSchedule) {
            unavailable.date             = date;
            unavailable.mechanic_id      = mechanicId;

            /**
             * when using the time from a date after daylight savings and adding
             * it to a date before daylight savings, moment is converting the hour to
             * be an hour later. Because of that, we set the hour, second, minute, millisecond
             * separately to ensure that daylight savings is unaffected.
             * bugfix/WOR-1155
             */
            unavailable.local_start_time = moment(date)
              .hour(moment(unavailable.local_start_time).hour())
              .millisecond(moment(unavailable.local_start_time).millisecond())
              .minute(moment(unavailable.local_start_time).minute())
              .second(moment(unavailable.local_start_time).second())
              .format('YYYY-MM-DDTHH:mm:ssZ');
            unavailable.local_end_time   = moment(date)
              .hour(moment(unavailable.local_end_time).hour())
              .millisecond(moment(unavailable.local_end_time).millisecond())
              .minute(moment(unavailable.local_end_time).minute())
              .second(moment(unavailable.local_end_time).second())
              .format('YYYY-MM-DDTHH:mm:ssZ');

            if (unavailable.id) {
              updateUnavailability.push(unavailable);
            }
            else {
              createUnavailability.push(unavailable);
            }
          }
        }
      }
    }

    if (isValidSchedule) {
      return self.save(createSchedule, updateSchedule, createUnavailability, updateUnavailability);
    }
    else {
      return $q.reject($translate.instant('JS_SPACE.MESSAGES.INVALID_SCHEDULE'));
    }
  };

  //  toggleDefaults        used to toggle the display of default
  //                        schedules on the schedule page.
  //  params: showDefaults  Boolean of whether or not to
  //                        show defaults.
  Schedule.prototype.toggleDefaults = function (showDefaults) {
    var self = this;

    return workshopAPI.post('/schedule/show', { start_date: self.weekRangeStart.format('YYYY-MM-DD'), include_default: showDefaults });
  };

  Schedule.prototype.createHoliday = function () {
    return $uibModal.open({
      controller : 'HolidayCtrl',
      templateUrl: HolidayModalHtml,
      windowClass: 'sm-modal'
    }).result;
  };

  Schedule.prototype.manageHolidays = function () {
    return $uibModal.open({
      controller : 'ManageHolidaysCtrl',
      templateUrl: ManageHolidaysModalHtml,
      windowClass: 'lg-modal',
      resolve    : {
        holidays: () => workshopAPI.get('/unavailable_times/holidays')
      }
    }).result;
  };

  Schedule.prototype.setUnavailableTimes = function () {
    return $uibModal.open({
      controller  : 'SetUnavailableTimesCtrl',
      controllerAs: '$ctrl',
      templateUrl : SetUnavailableTimesHtml,
      windowClass : 'sm-modal'
    }).result;
  };

  return Schedule;
}